import React from 'react';

import useDeviceInfo from '../../../hooks/useDeviceInfo';
import { CheckoutButtonContainer } from '../order-summary/checkout-container';

export default ({}) => {
    const { device } = useDeviceInfo(['device'], 'default');
    if (device !== 'mobile') {
        return null;
    }
    const payPalButtonProps = {
        btnStyle: { color: 'white', shape: 'sharp', label: undefined, height: 45 },
        disableLabelMessage: true,
    };
    return <CheckoutButtonContainer variation="horizontal" payPalButtonProps={payPalButtonProps} />;
};
